// extracted by mini-css-extract-plugin
export default {"customAlertContainer":"CustomAlert_customAlertContainer__FbHvx","customAlertChildrenContainer":"CustomAlert_customAlertChildrenContainer__SsL6x"};